import React from "react";
import Reveal from "./Reveal";

const FACTS = [
  {
    stat: "#2",
    label: "in the nation",
    desc: "Florida consistently ranks among the top states for traffic fatalities and serious auto accidents.",
  },
  {
    stat: "400K+",
    label: "crashes annually",
    desc: "The FLHSMV reports over 400,000 reportable crashes in Florida every year — one every 78 seconds.",
  },
  {
    stat: "2 yrs",
    label: "statute of limitations",
    desc: "Under HB 837 (2023), you now have only 2 years from the date of injury to file a claim.",
  },
];

const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function FloridaFacts() {
  return (
    <section
      data-testid="florida-facts-section"
      className="relative bg-[#0F2240] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-[#B89968]" />
              <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
                What Florida Drivers Should Know
              </span>
            </div>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              Florida is one of the <span className="italic gold-text">most dangerous states</span> to drive in.
            </h2>
            <p className="mt-6 text-[#CBD5E1] text-lg leading-relaxed max-w-md">
              Many accident victims accept an early insurance offer without
              realizing the true value of their claim. Before you sign
              anything, let us review it — at no cost to you.
            </p>
            <button
              onClick={scrollToForm}
              data-testid="florida-facts-cta"
              className="mt-8 inline-flex items-center gap-2 text-[#B89968] hover:text-[#CFB079] uppercase tracking-[0.22em] text-xs transition-colors"
            >
              Get My Case Reviewed →
            </button>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
          {FACTS.map((f, i) => (
            <Reveal
              key={f.stat}
              delay={i * 100}
              className="bg-[#15294C] border border-[#B89968]/15 p-6 md:p-7 hover:border-[#B89968]/40 transition-colors duration-500 flex flex-col"
              data-testid={`fl-fact-${i}`}
            >
              <div className="font-serif-display text-4xl md:text-5xl text-white leading-none mb-2">
                {f.stat}
              </div>
              <div className="text-xs uppercase tracking-[0.24em] text-[#B89968] mb-4">
                {f.label}
              </div>
              <div className="gold-rule mb-4" />
              <p className="text-[#94A3B8] text-sm leading-relaxed">{f.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>

      <p className="max-w-7xl mx-auto mt-12 px-6 md:px-10 lg:px-16 text-xs text-[#64748B]">
        Sources: Florida Department of Highway Safety and Motor Vehicles (FLHSMV);
        Florida House Bill 837 (2023).
      </p>
    </section>
  );
}
